if (!customElements.get('review-slider')) {
  customElements.define('review-slider', class SlickSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log('review-slider loaded');
      this.slider = this.querySelector('.review-slider__slider');
      this.prevArrow = this.querySelector('.review-slider__arrow-prev');
      this.nextArrow = this.querySelector('.review-slider__arrow-next');
      
      // Get settings from data attributes
      this.slidesMobile = parseInt(this.dataset.slidesMobile) || 1;
      this.slidesTablet = parseInt(this.dataset.slidesTablet) || 2;
      this.slidesDesktop = parseInt(this.dataset.slidesDesktop) || 3;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 3000;
      
      this.initializeSlider();
    }

    initializeSlider() {
      if(this.slider.classList.contains('slick-initialized')) {
        $(this.slider).slick('refresh');
        return false;
      } else {
        $(this.slider).slick({
          autoplay: this.autoplay,
          autoplaySpeed: this.autoplaySpeed,
          dots: false,
          arrows: true,
          prevArrow: this.prevArrow,
          nextArrow: this.nextArrow,
          infinite: true,
          draggable: true,
          mobileFirst: true,
          rows: 0,
          responsive: [
            {
              breakpoint: 0,
              settings: {
                slidesToShow: this.slidesMobile,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 750,
              settings: {
                infinite: true,
                slidesToShow: this.slidesTablet,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 990,
              settings: {
                infinite: true,
                slidesToShow: this.slidesDesktop,
                slidesToScroll: 1
              }
            }
          ]
        })
      }
    }
  })
}
